var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"modal",style:(_vm.userStyle),attrs:{"id":"alert-modal"}},[_c('div',{staticClass:"alert",class:_vm.alertType},[_c('strong',[_vm._v(_vm._s(_vm.content))])])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }